import AddTrip from "./AddTrip";
import AddVehicle from "./AddVehicle";
import PerfilSocial from "./PerfilSocial";
import DriverVehicle from "./DriverVehicle";
import Checkpoint from "./Checkpoint";
import AddCheckpoint from "./AddCheckpoint/AddCheckpoint";
import AddAreas from "./AddAreas/AddAreas";
import ConfirmDialog from "./Confirm";
import SaveName from "./SaveName";

export const Dialog = {
  AddTrip,
  AddVehicle,
  PerfilSocial,
  DriverVehicle,
  Checkpoint,
  AddCheckpoint,
  AddAreas,
  ConfirmDialog,
  SaveName
};
